var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  aaasas5161\n  "),_c('div',{staticClass:"gcse-search"})])
}]

export { render, staticRenderFns }